import '../googletag';
import { AdsAppView } from '@smithsonian/js/ads/views/AdsAppView';

export const PhotoContestAdsAppView = AdsAppView.extend({
    /*
     * Photo Contest Ads App View
     */

    /* photo contest configs */
    settings: [
        {
            name: 'defaultPhotoContestStream',
            // id: 'div-gpt-ad-chuckweasley-photocontest-stream',
            sizes: [[300, 250]],
            pos: ['photocontest-stream'],
            collapseEmpty: true,
            loading: 'instant', // options 'lazy' or 'instant'
        },
        {
            name: 'defaultPhotoContestTop',
            // id: 'div-gpt-ad-chuckweasley-photocontest-top',
            sizes: [[300, 250]],
            pos: ['photocontest-top'],
            collapseEmpty: true,
            platform: 'desktop',
            loading: 'instant',
        },
        {
            name: 'defaultPhotoContestBottom',
            // id: 'div-gpt-ad-chuckweasley-photocontest-bottom',
            sizes: [[300, 250]],
            pos: ['photocontest-bottom'],
            collapseEmpty: true,
            platform: 'desktop',
            loading: 'lazy',
        },
        {
            name: 'defaultPhotoContestHeader',
            //id: 'div-gpt-ad-chuckweasley-photocontest-header',
            sizes: [
                [728, 90],
                [970, 90],
                [970, 250],
            ],
            pos: ['photocontest-top'],
            collapseEmpty: true,
            platform: 'desktop',
            loading: 'instant',
        },
        {
            name: 'defaultPhotoContestMiddle',
            // id: 'div-gpt-ad-chuckweasley-photocontest-middle',
            sizes: [
                [728, 90],
                [970, 90],
                [970, 250],
            ],
            pos: ['photocontest-middle'],
            collapseEmpty: true,
            platform: 'desktop',
            loading: 'lazy',
        },
        {
            name: 'mobilePhotoContestHeader',
            // id: 'div-gpt-ad-chuckweasley-photocontest-header',
            sizes: [
                [300, 250],
                [320, 50],
                [300, 50],
            ],
            pos: ['photocontest-top'],
            collapseEmpty: true,
            platform: 'mobile',
            loading: 'instant',
        },
        {
            name: 'mobilePhotoContestStickyBottom',
            // id: 'div-gpt-ad-chuckweasley-photocontest-stickybottom',
            sizes: [
                [320, 50],
                [300, 50],
            ],
            pos: ['photocontest-bottom'],
            collapseEmpty: true,
            platform: 'mobile',
            loading: 'instant',
        },
    ],

    paginate: function (page) {
        // trigger ads refresh
        // check if pubads method exists
        // as it does not exist on the initial site load.
        var node = document.getElementById(
            'div-gpt-ad-chuckweasley-photocontest-stream-' + page
        );
        console.log('div-gpt-ad-chuckweasley-photocontest-stream-' + page);
        if (page && node) {
            this.adSlotSetup(page, node);
        }
    },
});
